/* eslint-disable */

import { HiX } from "react-icons/hi";
import SidebarCard from "components/sidebar/componentsrtl/SidebarCard";
import routes from "routes.js";
import { useEffect, useState } from "react";
import GroupOfLinks from "./components/GroupOfLinks";

const Sidebar = ({ open, onClose }) => {
    const [submenu, setSubmenu] = useState("submenu-Attivazioni");

    return (
        <div
            className={`sm:none duration-175 linear fixed !z-50 flex min-h-full flex-col bg-white pb-10 shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
                open ? "translate-x-0" : "-translate-x-96"
            }`}
        >
            <span
                className="absolute top-4 right-4 block cursor-pointer xl:hidden"
                onClick={onClose}
            >
                <HiX />
            </span>

            <div className={`mx-[56px] mt-[30px] flex items-center`}>
                <img
                    src="/img/logo.svg"
                    alt="Proxima"
                    className="mt-1 ml-1 h-12 w-48 text-[26px] font-bold uppercase text-navy-700 dark:text-white"
                />
            </div>
            <div className="mt-8 mb-7 h-px bg-gray-50 dark:bg-white/30" />
            {/* Nav item */}

            <ul className="mb-auto pt-1">
                <GroupOfLinks
                    hasNoSubmenus
                    name="Cruscotto"
                    submenu={submenu}
                    setSubmenu={setSubmenu}
                    path="homepage"
                    onClose={onClose}
                />

                {routes
                    .reduce((groupedRoutes, route) => {
                        if (route?.group) {
                            const { group } = route;
                            groupedRoutes[group - 1] =
                                groupedRoutes[group - 1] ?? [];
                            groupedRoutes[group - 1].push(route);
                        }
                        return groupedRoutes;
                    }, [])
                    .map((group, index) => {
                        return (
                            <GroupOfLinks
                                key={index}
                                group={group}
                                name={
                                    index === 0
                                        ? "Attivazioni"
                                        : index === 1
                                        ? "Server"
                                        : "Tenant"
                                }
                                submenu={submenu}
                                setSubmenu={setSubmenu}
                                onClose={onClose}
                            />
                        );
                    })}
            </ul>

            {/* Nav item end */}
        </div>
    );
};

export default Sidebar;
